import { TDescriptionValue } from 'shared/types/typographyComponents';

export const LIST: TDescriptionValue[][] = [
  [{ value: 'К платформе подключены более 50 банков и более 400 застройщиков по всей стране' }],
  [{ value: 'Ускорение сделок в 4 раза и снижение затрат' }],
  [{ value: 'Выпуск УКЭП и массовая регистрация объектов онлайн' }],
  [{ value: 'Сервис входит в группу Циан и является резидентом фонда «Сколково»' }],
];

export const DESCRIPTION = [
  [
    {
      value:
        'Облачный сервис регистрации сделок в Росреестре, интегрированный с ИТ-системами банков, застройщиков и агентств недвижимости.',
    },
  ],
];
